<template>
    <div class="lang arabic">
        <div class="notes">
            <div class="info">
                <h3 class="bullet01">في اليوم السابق لموعد الفحص الطبي</h3>
                <p class="bullet03 depth">يجب عليك عدم الإفراط في احتساء الخمر أو الإفراط في العمل. ننصحك بالاسترخاء والحصول على كمية كافية من النوم.</p>
                <p class="bullet03 depth">يرجى ملء الاستبيان مسبقا وإحضاره معك إلى قسم الفحص الطبي.</p>
    
                <h4 class="bullet02 depth">الصوم</h4>
                <p class="bullet03 depth">تناول وجبة خفيفة قبل الساعة 7 مساء.</p>
                <p class="bullet03 depth">لا يجب تناول أي طعام بعد الساعة 9 مساء. (بما في ذلك الماء أو العلكة أو السجائر)</p>
    
                <h4 class="bullet02 depth">عينة البراز،</h4>
                <p class="bullet03 depth">أخذ عينة البراز قبل يوم واحد من الفحص إذا أمكن.</p>
                <p class="bullet03 depth">وإذا كنت قد حددت موعدًا لمنظار القولون،فسنقدم لك دليلًا إرشاديًا منفصلًا للحصول على تفاصيل حول الاهتمام الغذائي وطريقة تناول عامل تطهير الأمعاء.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">في يوم الفحص</h3>
                <p class="bullet03 depth">يجب تجنب الإفطار والسجائر والعلكة وما إلى ذلك في يوم الفحص.</p>
                <p class="bullet03 depth">عند الزيارة، يرجى إحضار الاستبيان وحاوية أخذ عينات البراز والنظارات أو العدسات اللاصقة معك.</p>
                <p class="bullet03 depth">تتضمن أيضًا قائمة الفحص، اختبار البول، لذا قدم عينتك بعد زيارة مكتب الاستقبال.</p>
    
                <h4 class="bullet02 depth">الدواء</h4>
                <p class="bullet03 depth">أدوية ضغط الدم، مضادات التشنجات:خذ رشفة من الماء في صباح يوم الفحص (حوالي الساعة 6 صباحًا).</p>
                <p class="bullet03 depth">يجب إيقاف تناول جرعة الإنسولين أو أي أدوية للسكري من بداية الصيام : علاج السكري (بما في ذلك حقن الإنسولين)</p>
            </div>
            <div class="info">
                <h3 class="bullet01">غير ذلك</h3>
                <p class="bullet03 depth">يرجى عدم حمل الأشياء الثمينة معك</p>
                <p class="bullet03 depth">يجب على النساء في سن الإنجاب تأكيد حالة الحمل قبل الفحص الطبي.</p>
                <p class="bullet03 depth">نوصي المرضى الإناث إجراء الفحص خارج فترة الحيض،; يجب على النساء اللائي قمن باستئصال الرحم الخضوع لفحص أمراض النساء للتحقق من وجود أي خلل في الأعضاء الموجودة داخل منطقة الحوض.</p>
                <p class="bullet03 depth">
                    مضادات التجلط قد تؤدي إلى النزيف أثناء أخذ عينة بالمنظار أو استئصال ورم، يجب على المرضى الذين يتناولون مضادات التجلط (مثل الأسبرين) التشاور مع الطبيب المعالج ليتحقق ما إذا كان يجب الاستمرار أو تعليق الإدارة لمدة أسبوع قبل إجراء الفحص على الأكثر وإبلاغنا في يوم الفحص.
                </p>
                <p class="bullet03 depth">يرجى أن تكون بصحبة ولي الأمر إذا كنت تقوم بإجراء عملية منظار نصف تخدير، ولاحظ أنه لن يُسمح لك بقيادة السيارة لبقية اليوم.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">الأدوية المحظورة</h3>
                <p class="bullet03 depth">يجب إيقاف الأدوية المحظورة وأدوية مرض السكري التي تحتوي على الميتفورمين (مثل ديابيكس و چانومت و جلوبا و تراچينتا- ديو و اماريل - ام) لمدة 48 ساعة بعد الفحص إذا تم استخدام وسيط متباين في أي من الاختبارات.</p>
                <p class="bullet03 depth">
                    قد تؤدي الأدوية المضادة للتخثر ومضادات التجلط إلى النزيف أثناء أخذ عينة بالمنظار أو استئصال الورم;يجب على المرضى الذين يتناولون عقار مضاد للتجلط أو مضاد التخثر استشارة الطبيب المعالج ليتحقق ما إذا كان يجب الاستمرار أو تعليق الإدارة لمدة أسبوع قبل إجراء الفحص على الأكثر وإبلاغنا في يوم الفحص.
                </p>
    
                <ul class="notes__list">
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_01.jpg" alt=""></div>
                        <div class="tit">ديابيكس إكس آر</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_02.jpg" alt=""></div>
                        <div class="tit">زانويميت إكس آر</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_03.jpg" alt=""></div>
                        <div class="tit">غلابا تاب</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_04.jpg" alt=""></div>
                        <div class="tit">تراينتا - ديو</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_05.jpg" alt=""></div>
                        <div class="tit">أماريل – إم</div>
                    </li>
                </ul>
            </div>
    
            <div class="info">
                <h4 class="bullet02">أمثلة عن الأدوية المضادة للتخثر</h4>
                <ul class="notes__list">
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_06.jpg" alt=""></div>
                        <div class="tit">أسبرين بروتكت تاب</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_07.jpg" alt=""></div>
                        <div class="tit">ستريكس</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_08.jpg" alt=""></div>
                        <div class="tit">بلافيكس</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_09.jpg" alt=""></div>
                        <div class="tit">بليتال تاب</div>
                    </li>
                </ul>
            </div>
    
            <div class="info">
                <h4 class="bullet02">أمثلة عن مضادات التخثر</h4>
                <ul class="notes__list">
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_10.jpg" alt=""></div>
                        <div class="tit">ارفارين</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_11.jpg" alt=""></div>
                        <div class="tit">باراداكسا</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_12.jpg" alt=""></div>
                        <div class="tit">إكساريتو،</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_13.jpg" alt=""></div>
                        <div class="tit">إليكيس</div>
                    </li>
                    <li class="notes__item">
                        <div class="img"><img src="/resource/img/img_com03_14.jpg" alt=""></div>
                        <div class="tit">ليكسيانا.</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>